export default class NotTheRightPdfElementError extends Error {
  constructor(message) {
    super(message);
    this.name = 'NotTheRightPdfElementError';
  }
}
